import {
  GameSettingType,
  SpeedometerType,
} from "@1games-ru/region-shared/dist/enums/account/settings";
import { AnimatePresence, motion } from "motion/react";
import useAppSelector from "@/core/helpers/useAppSelector";
import { IS_DEV } from "@/domains/main/constants/other";
import useShowSpeedometer from "@/domains/hud/hooks/useShowSpeedometer";
import useVehicleState from "@/domains/hud/hooks/useVehicleState";
import HudSpeedometerClassic from "@/domains/hud/components/speedometer/HudSpeedometerClassic";
import HudSpeedometerMaximal from "@/domains/hud/components/speedometer/HudSpeedometerMaximal";
import HudSpeedometerMinimal from "@/domains/hud/components/speedometer/HudSpeedometerMinimal";
import HudSpeedometerStandart from "@/domains/hud/components/speedometer/HudSpeedometerStandart";
import { appliedBasicSettingsSelector } from "@/domains/settings/basic/slice";

const speedometerDict = {
  [SpeedometerType.Minimal]: HudSpeedometerMinimal,
  [SpeedometerType.Standard]: HudSpeedometerStandart,
  [SpeedometerType.Classic]: HudSpeedometerClassic,
  [SpeedometerType.Maximal]: HudSpeedometerMaximal,
};

type Props = {
  className?: string;
};

export default function HudSpeedometerContainer({ className }: Props) {
  const appliedBasicSettings = useAppSelector(appliedBasicSettingsSelector);
  const { isShow } = useShowSpeedometer();
  const vehicleState = useVehicleState();

  const Component = appliedBasicSettings
    ? speedometerDict[
        appliedBasicSettings[GameSettingType.SettingSpeedometerStyle] || SpeedometerType.Classic
      ]
    : null;

  const show = isShow || IS_DEV;

  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          initial={{ opacity: 0, translateY: "100%", height: 0 }}
          animate={{ opacity: 1, translateY: "none", height: "fit-content" }}
          transition={{
            duration: 0.2,
          }}
          exit={{ opacity: 0, translateY: "100%", height: 0 }}
          className={className}
        >
          <Component {...vehicleState} />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
